import React, {useContext} from "react";
import {GlobalContext} from "../../providers/GlobalProvider";
import StudentHomePage from "./StudentHomePage";
import InstructorHomePage from "./InstructorHomePage";

export default function HomePage ({  }) {
  const { user } = useContext(GlobalContext);

  return user.type ? user.type === 'TEACHER' ? <InstructorHomePage /> : <StudentHomePage /> : <></>;
}